export default "__VITE_ASSET__gYSPJiNm__"